module.exports = __webpack_public_path__ + "img/grid-02.c69dcabb.svg";